import { FormControl as BaseFormControl, FormControlProps } from 'baseui/form-control';

type Props = FormControlProps & {
  className?: string;
};

export const FormControl = (props: Props) => {
  return <BaseFormControl {...props}>{props.children}</BaseFormControl>;
};
